import UserPageHeader from './UserPageHeader';

export default UserPageHeader;
